import assign from 'lodash/assign';
import DispatchConstants from 'app/shared/constants/DispatchConstants';

const initState = () => ({
    addressList: [],
});

const autocomplete = (state = initState(), action = {}) => {
    const { type, payload } = action;

    switch (type) {
        case DispatchConstants.ADDRESS_AUTO_COMPLETE:
            return assign({}, state, payload);

        default:
            return state;
    }
};

export default autocomplete;
